var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Chip = function (_a) {
    var label = _a.label, onRemove = _a.onRemove;
    return (_jsxs("div", __assign({ className: "inline-flex items-center px-3 py-1 rounded-full bg-gray-200 text-gray-700 text-sm font-medium space-x-2" }, { children: [_jsx("span", { children: label }), onRemove && (_jsx("button", __assign({ onClick: onRemove, className: "hover:bg-gray-300 rounded-full p-0.5 focus:outline-none", "aria-label": "Remove chip" }, { children: _jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: "h-4 w-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" }, { children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M6 18L18 6M6 6l12 12" }) })) })))] })));
};
